<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  canManage: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['switch-view', 'add-template']);
const { t } = useI18n();
</script>

<template>
  <header class="border-b border-n-weak bg-n-solid-1 px-4 py-4 sm:px-6">
    <div
      class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div class="flex min-w-0 items-center gap-3">
        <Button
          type="button"
          variant="ghost"
          color="slate"
          size="md"
          icon="i-lucide-arrow-left"
          :aria-label="t('PIPELINE.MESSAGE_TEMPLATES.BACK_TO_PIPELINE')"
          @click="emit('switch-view', 'pipeline')"
        />
        <div class="min-w-0">
          <h1
            class="truncate text-xl font-semibold text-n-slate-12 sm:text-2xl"
          >
            {{ t('PIPELINE.MESSAGE_TEMPLATES.TITLE') }}
          </h1>
          <p class="mt-0.5 text-sm text-n-slate-11">
            {{ t('PIPELINE.MESSAGE_TEMPLATES.DESCRIPTION') }}
          </p>
        </div>
      </div>
      <Button
        v-if="canManage"
        type="button"
        variant="solid"
        color="blue"
        size="md"
        icon="i-lucide-plus"
        class="w-full sm:w-auto"
        @click="emit('add-template')"
      >
        {{ t('PIPELINE.MESSAGE_TEMPLATES.ADD') }}
      </Button>
    </div>
  </header>
</template>
